import moment, { Moment } from 'moment';

// get diff in months, inclusive of both min/max dates
const monthDiff = (minDate: Moment, maxDate: Moment) =>
  12 * (maxDate.year() - minDate.year()) - minDate.month() + maxDate.month() + 1;

export const monthsInRange = (minDate: Moment, maxDate: Moment): Moment[] =>
  Array.from({ length: monthDiff(minDate, maxDate) }, (_, i) =>
    moment(maxDate).startOf('month').subtract(i, 'months'),
  ).reverse();
